import React, { useEffect, useState } from 'react';
import { Box, Image, Link } from '@chakra-ui/react';
import AleaTable from '../../components/AleaTable/AleaTable';
import { ITableColumn } from '../../interfaces';
import { IDocument } from '../../interfaces/Document/IDocument.ts';
import AleaDownloadIcon from '../../icons/AleaDownloadIcon.tsx';
import DocumentService from '../../services/DocumentService.ts';
import { useTranslation } from 'react-i18next';

interface DocumentManagementTableProps {
  documents: IDocument[];
  isLoading: boolean;
  total: number;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  isSearchOpen: boolean;
  setIsSearchOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isTableListFetched: boolean;
}

const DocumentManagementTable: React.FC<DocumentManagementTableProps> = ({
  documents,
  isLoading,
  total
}) => {
  const { t } = useTranslation();
  const [categories, setCategories] = useState<string[]>([]);

  const columns: ITableColumn<IDocument>[] = [
    {
      key: 'format',
      label: t('fileFormat'),
      sortable: true,
      width: '76px',
      render: (doc: IDocument) => (
        <Image
          src={`/assets/images/icons/${doc.format.toLowerCase()}.svg`}
          height="34px"
        />
      ),
    },
    {
      key: 'name',
      label: t('documentName'),
      sortable: true,
      render: (doc: IDocument) => (
        <Link href={doc.file} isExternal color="alea.500">
          {doc.name}
        </Link>
      ),
    },
    {
      key: 'created_at',
      label: t('date'),
      sortable: true,
      render: (doc: IDocument) => {
        const date = new Date(doc.created_at);
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}.${(
          date.getMonth() + 1
        )
          .toString()
          .padStart(2, '0')}.${date.getFullYear()}`;
        return formattedDate;
      },
    },
    {
      key: 'download',
      label: '',
      sortable: false,
      render: (doc: IDocument) => (
        <Box
          as="button"
          textAlign="center"
          onClick={() => window.open(doc.file, '_blank')}
        >
          <AleaDownloadIcon />
        </Box>
      ),
      width: '50px',
    },
  ];

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const tags = await DocumentService.fetchAvailableTags();
        setCategories((prevCategories) => [...prevCategories, ...tags]);
      } catch (error) {
        console.error('Failed to fetch tags:', error);
      }
    };

    fetchTags();
  }, []);

  return (
    <AleaTable<IDocument>
      data={documents}
      columns={columns}
      categories={categories}
      isLoading={isLoading}
      total={total}
    />
  );
};

export default DocumentManagementTable;
